import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_7 = {
  for: "transfer-type",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mt-10 flex justify-between" }
const _hoisted_10 = { class: "flex flex-row-reverse" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "m-4" }, null, -1)
const _hoisted_14 = { key: 0 }

import { computed, onMounted, reactive, ref } from "vue";
import { SearchIcon } from "@heroicons/vue/outline";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import TransferAuthorityCreateModal from "@/components/user/transferAuthority/TransferAuthorityCreateModal.vue";
import TransferAuthorityCloseModal from "@/components/user/transferAuthority/TransferAuthorityCloseModal.vue";
import Modal from "@/components/common/Modal.vue";
import { TransferAuthorityActions } from "@/store/modules/transferAuthority/actions";
import { TransferAuthorityGetters } from "@/store/modules/transferAuthority/getters";
import {
  TransferAuthorityStatuses,
  TransferAuthorityTypes,
  TransferAuthorityUserTypes,
} from "@/store/modules/transferAuthority/state";
import TransferAuthorityMenu from "@/components/user/transferAuthority/TransferAuthorityActionMenu.vue";
import BgColoredLabel from "@/components/common/BgColoredLabel.vue";
import { t } from "@/i18n";
import { formatDateTime } from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const toast = useToast();

onMounted(async () => {
  const queryType = String(route.query.type ?? "").toUpperCase();
  if (
    queryType === TransferAuthorityUserTypes.USER ||
    queryType === TransferAuthorityUserTypes.IOUSER
  ) {
    filter.type = queryType as TransferAuthorityUserTypes;
  }
  await loadReset();
});

const dataProvider = computed(() => {
  return store.getters[TransferAuthorityGetters.GET_DATA_PROVIDER];
});
const items = computed(() => {
  return dataProvider.value.items;
});
const pager = computed(() => {
  return dataProvider.value.pager;
});

const getPage = async (page: number) => {
  await store.dispatch(TransferAuthorityActions.FETCH_DATA_PROVIDER, {
    page: page,
    type: filter.type,
  });
};

const filterType = ref(TransferAuthorityUserTypes.USER);
const table = computed(() => {
  const columns = [
    {
      label: t("common.status"),
      field: "status",
      sortable: false,
    },
    {
      label: t("transferAuthority.startDate"),
      field: "startedAt",
      sortable: false,
    },
    {
      label: t("transferAuthority.endDate"),
      field: "expiredAt",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ];

  if (filterType.value === TransferAuthorityUserTypes.USER) {
    columns.unshift({
      label: t("common.name"),
      field: "ioUserFio",
      sortable: false,
    });
  } else if (filterType.value === TransferAuthorityUserTypes.IOUSER) {
    columns.unshift({
      label: t("common.name"),
      field: "userFio",
      sortable: false,
    });
  }

  return {
    isLoading: false,
    columns: columns,
    rows: items.value,
    totalRecordCount: 0,
  };
});

// Loading data
const loadReset = async () => {
  try {
    await store.dispatch(TransferAuthorityActions.FETCH_DATA_PROVIDER, {
      page: 1,
      type: filter.type,
    });
    filterType.value = filter.type;
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || t("transferAuthority.loadError")
    );
  }
};

// Filter
const filter = reactive({
  type: TransferAuthorityUserTypes.USER,
});
const updateFilter = async () => {
  try {
    await store.dispatch(TransferAuthorityActions.FETCH_DATA_PROVIDER, {
      page: 1,
      type: filter.type,
    });
    filterType.value = filter.type;
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || t("transferAuthority.loadError")
    );
  }
};

const transferAuthorityUserTypes = [
  {
    label: t("transferAuthority.transferredRights"),
    value: TransferAuthorityUserTypes.USER,
  },
  {
    label: t("transferAuthority.receivedRights"),
    value: TransferAuthorityUserTypes.IOUSER,
  },
];
const types = {
  [TransferAuthorityTypes.FULL]: t("transferAuthority.full"),
  [TransferAuthorityTypes.PARTIAL]: t("transferAuthority.partial"),
};
const statuses = [
  {
    color: "bg-red-500",
    value: TransferAuthorityStatuses.CLOSED,
    label: t("transferAuthority.closed"),
  },
  {
    color: "bg-blue-500",
    value: TransferAuthorityStatuses.WAIT_CONFIRM,
    label: t("transferAuthority.waiting"),
  },
  {
    color: "bg-green-500",
    value: TransferAuthorityStatuses.ACTIVE,
    label: t("transferAuthority.active"),
  },
  {
    color: "bg-red-500",
    value: TransferAuthorityStatuses.DENIED,
    label: t("transferAuthority.denied"),
  },
];

// Create modal
const transferAuthorityCreateModalIsShow = ref(false);
const transferAuthorityCreateModalHideHandler = async () => {
  await loadReset();
  transferAuthorityCreateModalIsShow.value = false;
};

// Reason modal
const transferAuthorityReasonModalIsShow = ref(false);
const reason = ref("");
const closeReason = ref("");
const transferAuthorityReasonModalShow = (
  reasonText: string,
  closeReasonText: string
) => {
  transferAuthorityReasonModalIsShow.value = true;
  reason.value = reasonText;
  closeReason.value = closeReasonText;
};

// Close modal
const transferAuthorityId = ref<string | null>(null);
const transferAuthorityCloseModalIsShow = ref(false);
const transferAuthorityCloseModalShow = async (id: string) => {
  transferAuthorityId.value = id;
  transferAuthorityCloseModalIsShow.value = true;
};
const transferAuthorityCloseModalHideHandler = async () => {
  transferAuthorityCloseModalIsShow.value = false;
  await loadReset();
};

// Confirm
const transferAuthorityConfirm = async (id: string) => {
  try {
    await store.dispatch(TransferAuthorityActions.CONFIRM, { id });
    toast.success(t("transferAuthority.confirmSuccess"));
    await loadReset();
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || t("transferAuthority.confirmError")
    );
  }
};

// Deny
const transferAuthorityDeny = async (id: string) => {
  try {
    await store.dispatch(TransferAuthorityActions.DENY, { id });
    toast.success(t("transferAuthority.denySuccess"));
    await loadReset();
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || t("transferAuthority.denyError")
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("transferAuthority.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("transferAuthority.rightsType")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "transfer-type",
              class: "input-form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).type) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(transferAuthorityUserTypes, (type, index) => {
                return _createElementVNode("option", {
                  value: type.value,
                  key: index
                }, _toDisplayString(type.label), 9, _hoisted_8)
              }), 64))
            ], 512), [
              [_vModelSelect, _unref(filter).type]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateFilter())),
            class: "btn-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (transferAuthorityCreateModalIsShow.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("transferAuthority.create")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_unref(VueTableLite), {
        "data-pagination-scroll-anchor": "",
        "is-slot-mode": true,
        "is-loading": _unref(table).isLoading,
        columns: _unref(table).columns,
        rows: _unref(table).rows,
        total: _unref(table).totalRecordCount,
        sortable: false,
        "is-hide-paging": true,
        messages: { noDataAvailable: _unref(t)('common.noData') }
      }, {
        status: _withCtx((data) => [
          _createVNode(BgColoredLabel, {
            options: statuses,
            value: data.value.status
          }, null, 8, ["value"])
        ]),
        startedAt: _withCtx((data) => [
          _createTextVNode(_toDisplayString(_unref(formatDateTime)(data.value.startedAt)), 1)
        ]),
        expiredAt: _withCtx((data) => [
          _createTextVNode(_toDisplayString(_unref(formatDateTime)(data.value.expiredAt)), 1)
        ]),
        action: _withCtx((data) => [
          _createVNode(TransferAuthorityMenu, {
            type: _unref(filter).type,
            status: data.value.status,
            onConfirm: ($event: any) => (transferAuthorityConfirm(data.value.id)),
            onClose: ($event: any) => (transferAuthorityCloseModalShow(data.value.id)),
            onDeny: ($event: any) => (transferAuthorityDeny(data.value.id)),
            onReason: ($event: any) => (
            transferAuthorityReasonModalShow(
              data.value.reason,
              data.value.closeReason
            )
          )
          }, null, 8, ["type", "status", "onConfirm", "onClose", "onDeny", "onReason"])
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(TablePagination, {
          current: _unref(pager).currentPage,
          "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pager).currentPage) = $event)),
          "total-pages": _unref(pager).totalPages,
          "onUpdate:total-pages": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pager).totalPages) = $event)),
          "start-page": _unref(pager).startPage,
          "end-page": _unref(pager).endPage,
          onPageChanged: getPage
        }, null, 8, ["current", "total-pages", "start-page", "end-page"])
      ])
    ]),
    _createVNode(TransferAuthorityCreateModal, {
      show: transferAuthorityCreateModalIsShow.value,
      onHide: transferAuthorityCreateModalHideHandler
    }, null, 8, ["show"]),
    _createVNode(TransferAuthorityCloseModal, {
      id: transferAuthorityId.value,
      show: transferAuthorityCloseModalIsShow.value,
      onHide: transferAuthorityCloseModalHideHandler
    }, null, 8, ["id", "show"]),
    _createVNode(Modal, {
      title: _unref(t)('transferAuthority.reason'),
      show: transferAuthorityReasonModalIsShow.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (transferAuthorityReasonModalIsShow.value = false))
    }, {
      default: _withCtx(() => [
        (reason.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("transferAuthority.transferReason")), 1),
              _createElementVNode("p", null, _toDisplayString(reason.value), 1)
            ]))
          : _createCommentVNode("", true),
        (closeReason.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              (closeReason.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("b", null, _toDisplayString(_unref(t)("transferAuthority.closeReason")), 1),
                    _createElementVNode("p", null, _toDisplayString(closeReason.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "show"])
  ], 64))
}
}

})